<div
    class="tw:bg-white tw:shadow-lg tw:py-4 tw:px-4 tw:rounded-lg tw:w-[calc(100vw-2rem)]"
    [ngClass]="{
        'tw:md:w-[360px]': size === 'small' || !size,
        'tw:md:w-[640px]': size === 'medium',
        'tw:md:w-[1024px]': size === 'large',
        'tw:max-h-[90vh] tw:md:max-h-[100vh] tw:overflow-y-auto': !containInnerScroll,
        'tw:max-h-[90vh] tw:md:max-h-[100vh] tw:overflow-hidden': containInnerScroll,
    }"
>
    <ng-content />
</div>
